import * as React from "react"
import {
  Create,
} from "react-admin"
import ContactForm from "./ContactForm"

const ContactTitle = () => {
  return <span>{'聯絡表單'}</span>;
};

const ContactCreate = () => (
  <Create 
    title={<ContactTitle/>}
  >
    <ContactForm 
      formType="create"
    />
  </Create>
)

export default ContactCreate